import { OperatingSystemService } from './operating-system-service';

class KeyHandlerServiceClass {
  eventHasControlPressed(event) {
    if (!event) {
      return false;
    }
    if (OperatingSystemService.isMac()) {
      return event.metaKey;
    }
    return event.ctrlKey;
  }

  setControlPressed(event) {
    // returning a spread does not work since all the usages aren't using the value, they're expecting the event to be modified.
    if (OperatingSystemService.isMac()) {
      // oxlint-disable-next-line no-param-reassign
      event.metaKey = true;
      return;
    }
    // oxlint-disable-next-line no-param-reassign
    event.ctrlKey = true;
  }
}

export const KeyHandlerService = new KeyHandlerServiceClass();
